import React from 'react'
import { connect } from 'react-redux'
import { toast } from 'react-toastify'
import { Tooltip, IconButton } from '@material-ui/core'
import DeleteIcon from '@material-ui/icons/Delete'
import { eliminarBodegaBuque } from '../actions/PlanDeEmbarqueActions'

function DeleteBodegaBuque (props) {
  const { buque, bodega } = props

  const handleSubmit = () => {
    const { detalleBodegas } = props
    const bodegaDetallada = detalleBodegas.find((d) => d.bodega.trim() === bodega.trim())
    if (!bodegaDetallada) {
      props.eliminarBodegaBuque(buque, bodega)
    } else {
      toast.error(`La ${bodega} no se puede eliminar, porque ya esta cargada en el plan de embarque bodega.`)
    }
  }

  return (
    <Tooltip title={'Eliminar bodega'}>
      <IconButton onClick={handleSubmit}>
        <DeleteIcon />
      </IconButton>
    </Tooltip>
  )
}

const mapStateToProps = (state) => ({
  detalleBodegas: state.buque.detalleBodegas
})

const mapActionsToProps = {
  eliminarBodegaBuque
}

const withRedux = connect(mapStateToProps, mapActionsToProps)
export default withRedux(DeleteBodegaBuque)
